import { yupResolver } from "@hookform/resolvers/yup";
import { LibraryAPI, TicketAPI } from "api";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";
import { formatDate } from "utils/date_utils";
import TicketPrint from "modules/reporting/TicketPrint/TicketPrint";

const schema = yup.object({
  ticketNumber: yup.string().required("Ticket Number is required"),

  // service: yup.string().required("Service is required"),

  ticketDate: yup.string().required("Date is required"),

  status: yup.string(),

  // amount: yup
  //   .number()
  //   .typeError("Amount is required")
  //   .min(0, "Amount cannot be negative")
  //   .required("Amount is required"),

  services: yup.array().of(
    yup.object().shape({
      serviceName: yup.string().required("Title is required"),
      serviceFee: yup
        .number()
        .typeError("Amount is required")
        .min(0, "Amount cannot be negative")
        .required("Amount is required"),
      // status: yup.boolean(),
    }),
  ),

  amountPaid: yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" || isNaN(value) ? null : value,
    )
    .min(0, "Paid amount cannot be negative")
    .typeError("Paid amount must be a number"),

  patientId: yup.string().required("Patient is required"),
  physicianId: yup.string().required("Physician is required"),
});

const AddTicket = () => {
  const printRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      services: [{}],
    },
  });
  const { handleSubmit, reset, setValue } = methods;

  const [ticketData, setTicketData] = useState(null);

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0,
      amountPaid: data?.amountPaid ?? 0,
    };

    console.log(myData);

    try {
      if (location?.state) {
        setLoading(true);
        await TicketAPI.post(myData);
        setLoading(false);
        toast.success("Record updated successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        setLoading(true);
        await TicketAPI.post(myData);
        setLoading(false);
        toast.success("Record created successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });

      setTicketData(myData);

      setTimeout(() => {
        printRef.current.handlePrint();
        navigate(-1);
      }, 100);
    } catch (error) {
      toast.error("Something Went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location.state) {
      reset(location.state);
      setValue("ticketDate", formatDate(location?.state?.ticketDate));
    }
  }, [setValue]);

  return (
    <>
      <div className="py-2">
        <BreadCrumb />
      </div>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Row className="g-3">
            <Col xs={12}>
              <Card>
                <Card.Body>
                  <Row className="flex-between-center">
                    <Col md>
                      <h5 className="mb-2 mb-md-0">Ticket</h5>
                    </Col>
                    {/* <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
            >
              Discard
            </Button>
            <Button variant="primary" type="submit">
              Add User
            </Button>
          </Col> */}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={12}>
              <BasicInformation />
            </Col>
          </Row>
        </Form>
      </FormProvider>
      <div style={{ display: "none" }}>
        <TicketPrint ref={printRef} ticket={ticketData} />
      </div>
    </>
  );
};

export default AddTicket;
